"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Card = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const Box_1 = require("./Box");
const color_1 = require("../constants/color");
const theme_1 = require("../constants/theme");
/**
 * @deprecated Use `Paper` instead.
 */
exports.Card = (0, styled_1.default)(Box_1.Box)(({ border, borderColor, ...props }) => {
    const borderStyle = `6px solid ${borderColor ?? color_1.Color.LIGHTER_BLUE}`;
    return {
        backgroundColor: props.backgroundColor ?? color_1.Color.WHITE,
        border: theme_1.theme.border.style.thin,
        borderBottom: border === 'bottom' ? borderStyle : undefined,
        borderLeft: border === 'left' ? borderStyle : undefined,
        borderRadius: theme_1.theme.border.radius.normal,
        borderTop: border === 'top' ? borderStyle : undefined,
        boxShadow: props.elevated
            ? theme_1.theme.boxShadow.elevated
            : theme_1.theme.boxShadow.normal,
        boxSizing: 'border-box',
        cursor: props.cursor,
        display: 'flex',
        flexDirection: 'column',
        userSelect: props.userSelect,
        whiteSpace: props.whiteSpace,
        ...(0, Box_1.boxBase)(props),
        ...(props.hoverable
            ? {
                cursor: 'pointer',
                ':hover': {
                    backgroundColor: props.backgroundColor ?? color_1.Color.LIGHTEST_BLUE,
                },
            }
            : {}),
    };
});
